import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "h4 d-none" }
const _hoisted_2 = ["height", "width"]
const _hoisted_3 = { transform: "translate(32.400331,-164.07887)" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "m 913,1512 -73,-16 v -197 -197 l -62,20 c -48,15 -85,19 -153,16 -78,-3 -100,-7 -156,-35 -82,-40 -140,-102 -182,-191 -27,-58 -32,-81 -35,-166 -5,-118 8,-189 51,-269 61,-115 166,-177 301,-177 81,0 143,18 192,55 18,14 35,25 38,25 2,0 6,-15 8,-32 l 3,-33 h 100 100 v 605 605 l -30,1 c -16,1 -63,-5 -102,-14 z m -123,-596 45,-22 3,-67 c 6,-138 -33,-250 -104,-300 -33,-23 -51,-28 -97,-28 -113,0 -168,68 -169,206 0,160 88,253 227,239 27,-3 70,-15 95,-28 z",
  id: "path10"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  d: "m 3902,1513 -72,-15 2,-592 3,-591 h 100 100 l 3,203 c 1,118 6,202 12,200 5,-2 81,-94 170,-206 l 160,-202 h 119 c 99,0 120,3 125,16 3,9 6,17 6,19 0,2 -83,101 -186,221 l -185,217 39,41 c 190,202 243,266 237,285 -6,20 -14,21 -124,21 H 4293 L 4174,986 c -65,-80 -122,-145 -126,-145 -4,-1 -9,153 -10,342 l -3,342 -30,2 c -16,0 -63,-6 -103,-14 z",
  id: "path12"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("path", {
  d: "m 6273,1512 -73,-16 v -197 -197 l -62,20 c -48,15 -85,19 -153,16 -78,-3 -100,-7 -156,-35 -82,-40 -140,-102 -182,-191 -27,-58 -32,-81 -35,-166 -5,-118 8,-189 51,-269 61,-115 166,-177 301,-177 81,0 143,18 192,55 18,14 35,25 38,25 2,0 6,-15 8,-32 l 3,-33 h 100 100 v 605 605 l -30,1 c -16,1 -63,-5 -102,-14 z m -123,-596 45,-22 3,-67 c 6,-138 -33,-250 -104,-300 -33,-23 -51,-28 -97,-28 -113,0 -168,68 -169,206 0,160 88,253 227,239 27,-3 70,-15 95,-28 z",
  id: "path14"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("path", {
  d: "m 2475,1325 c -5,-2 -45,-11 -87,-20 l -77,-17 -3,-76 -3,-77 -47,-3 -47,-3 -15,-52 c -34,-121 -33,-124 54,-129 l 55,-3 5,-235 c 6,-266 13,-295 81,-354 52,-44 98,-56 212,-56 h 95 l 17,77 c 23,101 19,107 -79,113 -60,4 -81,9 -91,23 -17,24 -27,151 -23,307 l 3,125 95,5 95,5 3,76 c 2,54 -1,79 -11,87 -7,6 -51,12 -97,14 l -85,3 -3,85 c -3,94 -13,117 -47,105 z",
  id: "path16"
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("path", {
  d: "m 1499,1122 c -109,-36 -181,-101 -233,-212 -27,-57 -31,-78 -34,-172 -8,-213 66,-348 227,-415 80,-32 206,-32 276,1 28,12 56,30 64,39 20,25 29,21 33,-15 l 3,-33 h 100 100 l 3,348 2,347 -60,39 c -97,63 -166,83 -305,87 -97,3 -131,1 -176,-14 z m 291,-200 35,-17 -2,-99 c -2,-122 -16,-184 -54,-235 -37,-52 -78,-72 -144,-72 -115,0 -174,70 -175,207 0,114 49,197 136,230 48,18 154,11 204,-14 z",
  id: "path18"
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("path", {
  d: "m 3079,1122 c -109,-36 -181,-101 -233,-212 -27,-57 -31,-78 -34,-172 -8,-213 66,-348 227,-415 80,-32 206,-32 276,1 28,12 56,30 64,39 20,25 29,21 33,-15 l 3,-33 h 100 100 l 3,348 2,347 -60,39 c -97,63 -166,83 -305,87 -97,3 -131,1 -176,-14 z m 291,-200 35,-17 -2,-99 c -2,-122 -16,-184 -54,-235 -37,-52 -78,-72 -144,-72 -115,0 -174,70 -175,207 0,114 49,197 136,230 48,18 154,11 204,-14 z",
  id: "path20"
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("path", {
  d: "m 6876,1121 c -126,-42 -226,-145 -262,-268 -24,-81 -16,-251 14,-318 35,-78 71,-123 131,-166 83,-60 169,-82 294,-77 89,3 110,8 167,35 95,45 143,91 187,181 l 38,76 v 130 c 0,126 -1,133 -32,198 -40,86 -106,151 -191,191 -59,28 -78,31 -177,34 -88,3 -122,-1 -169,-16 z m 261,-207 c 60,-35 94,-109 94,-201 0,-38 -5,-82 -11,-97 -32,-84 -99,-129 -196,-130 -51,-1 -68,4 -109,29 -67,41 -97,102 -97,196 0,115 55,200 148,229 44,14 124,2 171,-26 z",
  id: "path22"
}, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("path", {
  d: "m 4692,1118 c -16,-16 -17,-412 -1,-525 18,-134 66,-215 152,-261 48,-25 61,-27 163,-27 107,0 112,1 162,32 l 51,31 3,-26 3,-27 h 100 100 v 405 405 h -100 -100 l -5,-241 -5,-240 -30,-59 c -36,-70 -76,-95 -151,-95 -62,0 -97,24 -115,78 -8,23 -15,131 -18,297 l -6,260 -95,3 c -66,2 -99,-1 -108,-10 z",
  id: "path24"
}, null, -1)
const _hoisted_12 = [
  _hoisted_4,
  _hoisted_5,
  _hoisted_6,
  _hoisted_7,
  _hoisted_8,
  _hoisted_9,
  _hoisted_10,
  _hoisted_11
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: _ctx.routeName !== null ? { name: _ctx.routeName } : '/',
    id: "logo",
    class: _normalizeClass(_ctx.aClass ? _ctx.aClass : '')
  }, {
    default: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.$beautify.firstLetterUppercase(_ctx.$config('appConfig', 'name'))), 1),
      (_openBlock(), _createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        version: "1.1",
        viewBox: "0 0 253.78876 43.592258",
        height: _ctx.width ? (_ctx.width * 43.592258) / 100 : (93 * 43.592258) / 100,
        width: _ctx.width ? _ctx.width : '93'
      }, [
        _createElementVNode("g", _hoisted_3, [
          _createElementVNode("g", {
            style: _normalizeStyle(
						_ctx.fill
							? 'fill:' + _ctx.fill
							: 'fill: rgb(22.745098%, 7.45098%, 32.941176%)'
					),
            transform: "matrix(0.03527778,0,0,-0.03527778,-41.254646,217.94804)",
            id: "g26"
          }, _hoisted_12, 4)
        ])
      ], 8, _hoisted_2))
    ]),
    _: 1
  }, 8, ["to", "class"]))
}